import React from 'react';
import { List } from 'semantic-ui-react';
var defaultProps = {
  isHorizontal: false,
  animated: false,
  celled: false,
  inlineHours: false
};
export default function HoursOfOperationDaily(props) {
  var hourGroups = props.hourGroups,
    isHorizontal = props.isHorizontal,
    animated = props.animated,
    celled = props.celled,
    inlineHours = props.inlineHours;
  return /*#__PURE__*/React.createElement(List, {
    horizontal: isHorizontal,
    animated: animated,
    celled: celled,
    relaxed: true
  }, hourGroups.map(function (hourGroup) {
    var dayLabel = hourGroup.dayLabel,
      hoursValue = hourGroup.hoursValue;
    return /*#__PURE__*/React.createElement(List.Item, {
      key: dayLabel
    }, /*#__PURE__*/React.createElement(List.Content, null, /*#__PURE__*/React.createElement(List.Header, {
      as: "header",
      className: "h5 day-label"
    }, dayLabel, inlineHours && ": ".concat(hoursValue.join(' | '))), !inlineHours && /*#__PURE__*/React.createElement(List.Description, null, /*#__PURE__*/React.createElement("ul", {
      className: "unstyled-list"
    }, hoursValue.map(function (hour) {
      return /*#__PURE__*/React.createElement("li", {
        key: hour
      }, hour);
    })))));
  }));
}
HoursOfOperationDaily.defaultProps = defaultProps;